import axios from 'axios';
import { addDays, parseISO } from 'date-fns';
import React, { useCallback, useEffect, useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { customSelectStyle } from '../../../../_metronic/_partials/dropdowns/ReactSelectCustomStyle';
import { config } from '../../../../config/envs';
import { ACTIVE_TABS, BENEFITS_TABS_CONFIG, DATE_INITIAL } from './constants';
import BenefitsTable from './BenefitsTable';
import Abas from './Abas';

export default function Creditos(props) {
  const [features, setFeatures] = useState([]);
  const [activeTab, setActiveTab] = useState(ACTIVE_TABS.BILHETAGEM);
  const [refreshKey, setRefreshKey] = useState(0);

  const [feature, setFeature] = useState(null);
  const [valid, setValid] = useState(DATE_INITIAL);
  const [count, setCount] = useState(0);
  const [releaseReason, setReleaseReason] = useState('');

  const getFeatures = useCallback(async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + '/subscription/features',
      );
      if (response.data && response.data.features) {
        setFeatures(response.data.features);
      }
    } catch (err) {
      toast.error('Ocorreu um erro ao carregar as features.');
    }
  }, [setFeatures]);

  const addBenefit = async () => {
    if (feature === null || count === '' || count == 0 || valid == '') {
      alert('Preencha todos os campos.');
      return;
    }
    if (parseISO(valid) > addDays(new Date(), 30)) {
      alert(
        'Não é possível adicionar benefícios com mais de 30 dias de validade.',
      );
      return;
    }

    if (!window.confirm('Confirma?')) {
      return;
    }
    try {
      const response = await axios.post(
        config.app.adminBaseUrl + `/subscription/addBenefit`,
        {
          clientId: Number(props.cliente_id),
          featureId: feature.id,
          count: Number(count),
          validUntil: valid,
          releaseReason: releaseReason,
        },
      );
      if (
        response.data &&
        response.data.success &&
        response.data.success === true
      ) {
        toast.success('Incluído com sucesso!');
        setRefreshKey((prev) => prev + 1);
      }
    } catch (err) {
      toast.error('Ocorreu um erro ao salvar, tente novamente.');
    }
  };

  useEffect(() => {
    getFeatures();
  }, [getFeatures]);

  const activeTabConfig = BENEFITS_TABS_CONFIG[activeTab];

  return (
    <>
      <h2>Benefícios</h2>

      <Abas activeTab={activeTab} onTabChange={setActiveTab} />

      <BenefitsTable
        key={activeTab}
        cliente_id={props.cliente_id}
        path={activeTabConfig.path}
        errorMessage={activeTabConfig.errorMessage}
        refreshKey={refreshKey}
      />

      {!props.formik.values.deleted_at && (
        <>
          <h3>Incluir benefício</h3>
          <div className="row">
            <div className="col-xl-12">
              <label className="form-label mb-0">Funcionalidade</label>
              <Select
                name="feature"
                theme={customSelectStyle}
                options={features}
                onChange={(value) => setFeature(value)}
                value={feature}
                placeholder="Selecione.."
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                isClearable={false}
                noOptionsMessage={() => <span>Sem resultados.</span>}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <label className="form-label mb-0">Quantidade</label>
              <input
                type="number"
                className="form-control"
                name="count"
                value={count}
                onChange={(evt) => setCount(evt.target.value)}
                minLength={0}
                min={0}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <label className="form-label mb-0">Valido até</label>
              <input
                type="date"
                className="form-control"
                name="valid"
                value={valid}
                onChange={(evt) => setValid(evt.target.value)}
              />
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-xl-12">
              <label className="form-label mb-0">
                Motivo da liberação do bônus
              </label>
              <input
                type="text"
                className="form-control"
                name="releaseReason"
                value={releaseReason}
                onChange={(evt) => setReleaseReason(evt.target.value)}
              />
            </div>
          </div>

          <button
            type="button"
            className="btn btn-primary"
            onClick={addBenefit}
          >
            Incluir Benefício
          </button>
        </>
      )}
    </>
  );
}
